// frontend/src/pages/TermsConditions.js

import React from 'react';
import { motion } from 'framer-motion';

const TermsConditions = () => {
  return (
    <motion.div
      className="min-h-screen bg-gradient-to-b from-white to-gray-50 py-12 px-4"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-2xl mx-auto bg-white rounded shadow-md p-8">
        <h1 className="text-3xl font-heading text-primary mb-6">
          Allgemeine Geschäftsbedingungen (AGB)
        </h1>

        <p className="mb-4 text-gray-700">
          <strong>für das journalistische Jugendprojekt Entecity.ch</strong>
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>1. Geltungsbereich</strong>
          <br />
          Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung der
          Webseite <em>entecity.ch</em> sowie für die Teilnahme am journalistischen
          Jugendprojekt im Rahmen des Schulunterrichts. Mit der Nutzung der
          Webseite und / oder der Beteiligung am Projekt erkennen die Teilnehmenden
          diese AGB an.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>2. Ziel des Projekts</strong>
          <br />
          Das Projekt <em>entecity.ch</em> dient der journalistischen Bildung /
          Medienbildung von Schülerinnen und Schülern und bietet ihnen eine
          Plattform zur Veröffentlichung eigener Onlineartikel. Die Inhalte sollen
          informativ und sachlich recherchiert sein und journalistischen
          Grundansprüchen genügen.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>3. Teilnahme und Nutzung</strong>
          <br />
          3.1. Teilnahmeberechtigt sind Schülerinnen und Schüler der Schule
          Entfelden.
          <br />
          3.2. Die Anmeldung und Teilnahme erfolgen über den Schulunterricht unter
          Anleitung der betreuenden Lehrkräfte.
          <br />
          3.3. Alle Inhalte werden vor der Veröffentlichung von den
          verantwortlichen Lehrkräften oder Redaktionsmitgliedern geprüft.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>4. Verhaltensregeln und Verantwortlichkeiten</strong>
          <br />
          4.1. Die Teilnehmenden verpflichten sich, keine Inhalte zu veröffentlichen,
          die gegen geltendes Recht, die journalistischen Grundsätze oder die guten
          Sitten verstossen.
          <br />
          4.2. Plagiate sowie Inhalte mit diskriminierenden, beleidigenden oder
          gewaltverherrlichenden Aussagen sind untersagt.
          <br />
          4.3. Die verantwortliche Lehrperson trägt die Verantwortung für die
          veröffentlichten Inhalte.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>5. Urheberrecht und Nutzungsrechte</strong>
          <br />
          5.1. Die Schülerinnen und Schüler behalten die Urheberrechte an ihren Texten,
          gewähren der Webseite jedoch ein nicht-exklusives Nutzungsrecht zur
          Veröffentlichung.
          <br />
          5.2. Eine Weiterverwertung der Inhalte durch Dritte ist ohne Zustimmung der
          Urhebenden nicht gestattet.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>6. Haftungsausschluss</strong>
          <br />
          6.1. Die Webseite <em>entecity.ch</em> übernimmt keine Haftung für die
          Richtigkeit, Vollständigkeit und Aktualität der veröffentlichten Artikel.
          <br />
          6.2. Die Plattform haftet nicht für Schäden, die durch die Nutzung der
          Webseite entstehen, es sei denn, diese sind auf grobe Fahrlässigkeit oder
          Vorsatz zurückzuführen.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>7. Datenschutz</strong>
          <br />
          7.1. Personenbezogene Daten der Teilnehmenden werden nur im Rahmen des Projekts
          und unter Beachtung der geltenden Datenschutzbestimmungen verarbeitet.
          <br />
          7.2. Es erfolgt keine Weitergabe von Daten an Dritte ohne ausdrückliche
          Zustimmung der Betroffenen.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>8. Beendigung der Teilnahme</strong>
          <br />
          8.1. Teilnehmende können jederzeit aus dem Projekt ausscheiden.
          <br />
          8.2. Die Redaktion behält sich das Recht vor, Beiträge zu löschen oder
          Teilnehmende auszuschliessen, die gegen die AGB verstossen.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>9. Änderungen der AGB</strong>
          <br />
          9.1. Die Redaktion behält sich das Recht vor, diese AGB jederzeit anzupassen.
          <br />
          9.2. Änderungen werden auf der Webseite bekannt gegeben und treten nach einer
          angemessenen Frist in Kraft.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>10. Schlussbestimmungen</strong>
          <br />
          Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die
          Wirksamkeit der übrigen Bestimmungen unberührt.
        </p>
      </div>
    </motion.div>
  );
};

export default TermsConditions;
